import script from "./add-subscription.vue?vue&type=script&lang=ts&setup=true"
export * from "./add-subscription.vue?vue&type=script&lang=ts&setup=true"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

const __exports__ = script;

export default __exports__